import Distributions from "./Distributions";

export default Distributions;